
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { store, ShopModule }  from "@returns-centre/store";


interface AppButtonVariants {
    default: boolean;
    warning: boolean;
    info: boolean;
    danger: boolean;
    success: boolean;
    primary: boolean
    dark: boolean,
    light: boolean
}

interface AppButtonSize {
    default: boolean;
    small: boolean
}

@Component
export default class AppButton extends Vue {
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: 'default' }) variant!: string
    @Prop({ default: false }) isProcessing!: boolean;
    @Prop({ default: false }) rounded!: boolean;
    @Prop({ default: 'default' }) size!: string;

    variants: AppButtonVariants = {
        default: false,
        warning: false,
        info: false,
        danger: false,
        success: false,
        primary: false,
        dark: false,
        light: false,
    }

    sizes: AppButtonSize = {
        default: false,
        small: false,
    }

    shopModule = getModule(ShopModule, store);

    get buttonClasses() {

        this.variants[this.variant as keyof AppButtonVariants] = true;
        this.sizes[this.size as keyof AppButtonSize] = true;

        return {
            'TRC-AppButton': 1,
            'TRC-AppButton--Disabled': this.disabled,
            'TRC-AppButton--Rounded': this.rounded,
            'TRC-AppButton--Default': this.variants['default'],
            'TRC-AppButton--Warning': this.variants['warning'],
            'TRC-AppButton--Info': this.variants['info'],
            'TRC-AppButton--Danger': this.variants['danger'],
            'TRC-AppButton--Success': this.variants['success'],
            'TRC-AppButton--Primary': this.variants['primary'],
            'TRC-AppButton--Dark': this.variants['dark'],
            'TRC-AppButton--Light': this.variants['light'],
            'TRC-AppButton--SizeDefault': this.sizes['default'],
            'TRC-AppButton--SizeSmall': this.sizes['small'],
        }
    }
    onClick() {
        this.$emit('click')
    }
}
